import { Navigate, useTypedParams } from '@sorare/routing';
import { ANY_SPORT_SERIES_MARKET_COMMON_PACKS_GROUP } from '@sorare/core/src/constants/__generated__/routes.ts';
import { useSportContext } from '@sorare/core/src/contexts/sport/index.ts';

import type { PageParams } from './__generated__/routeParams';

const CommonPacksTypePage = () => {
  const { group } = useTypedParams<PageParams>();
  const { generateSportContextPath } = useSportContext();

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_SERIES_MARKET_COMMON_PACKS_GROUP, {
        params: { group },
      })}
      replace
      keepSearchParams
    />
  );
};
export default CommonPacksTypePage;
